import useAxios from 'hooks/useAxios';

export async function getBlackjackV2Tables(params = {}) {
  const api = useAxios();

  try {
    const res = await api.get('/blackjack/all-tables', { params });
    return res;
  } catch (err) {
    return err;
  }
}
